import React, { useEffect, useRef, useState } from "react";
import "../styles/message-dropdown.scss";
import actions from "../actions/actions";
import { GuiButton } from "../components/global-ui/gui-button";

const MessageDropdown = ({ isEditing, from, isUserViewOnly = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const blankAlert = {
    name: "",
    isScheduled: false,
    subject: "",
    htmlMessage: "",
    allGroups: false,
    groups: [],
    isEmergency: false,
    attachments: [],
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick);
    }

    // Cleanup event listener when component unmounts
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [isOpen]);

  const handleSelect = (type) => {
    setIsOpen(false);

    switch (type) {
      case "text":
        actions.alerts.showEditAlert({ ...blankAlert, alertType: 3 }, from);

        break;
      case "email":
        actions.alerts.showEditAlert({ ...blankAlert, alertType: 2 }, from);

        break;
      case "voice":
        actions.alerts.showEditAlert({ ...blankAlert, alertType: 1 }, from);

        break;
      default:
        break;
    }
  };

  return (
    <div className="message-dropdown" ref={dropdownRef}>
      <GuiButton
        className="dropdown-button"
        onClick={handleToggle}
        disabled={isEditing || isUserViewOnly}
      >
        New Message <i className="fa fa-chevron-down"></i>
      </GuiButton>
      {isOpen && (
        <div className="dropdown-menu">
          <div className="dropdown-item" onClick={() => handleSelect("text")}>
            <i className="fa fa-mobile"></i> <span>Text</span>
          </div>
          <div className="dropdown-item" onClick={() => handleSelect("email")}>
            <i className="fa fa-envelope"></i> <span>Email</span>
          </div>
          <div className="dropdown-item" onClick={() => handleSelect("voice")}>
            <i className="fa fa-microphone"></i> <span>Voice</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageDropdown;
